import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20illustration%20with%20soft%20flowing%20gradients%20in%20coral%20pink%20peach%20and%20cream%20tones%2C%20gentle%20wavy%20organic%20shapes%2C%20subtle%20geometric%20patterns%2C%20dreamy%20ethereal%20atmosphere%2C%20elegant%20minimalist%20composition%2C%20smooth%20texture%2C%20soft%20lighting%2C%20no%20text%2C%20modern%20clean%20aesthetic%2C%20digital%20art%20style%20with%20watercolor%20influence%2C%20harmonious%20blend%20of%20warm%20hues&width=1920&height=900&seq=hero-bg-comic-wave&orientation=landscape"
          alt="韩漫画网 - 海量正版漫画在线阅读平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-[35%] flex flex-col items-center lg:items-start text-center lg:text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
              海量正版漫画
              <br />
              <span className="text-accent-300">免费在线阅读</span>
            </h1>
            <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-8 max-w-md">
              韩漫画网设有免费漫画弹窗入口，作为海量正版漫画在线阅读平台，
              内容安全可靠，让您安心享受高质量漫画资源。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/romance"
                className="inline-flex items-center px-7 py-3 text-base font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                开始阅读
                <span className="w-5 h-5 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center px-7 py-3 text-base font-medium rounded-full bg-background-50/15 text-background-50 hover:bg-background-50/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
              >
                了解更多
              </Link>
            </div>

            <div className="flex items-center gap-6 mt-8">
              {[
                { value: '10,000+', label: '正版漫画' },
                { value: '500万+', label: '活跃读者' },
                { value: '99.9%', label: '安全可靠' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-background-50">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[35%] relative">
            <div className="w-[260px] md:w-[320px] mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20couple%20in%20warm%20embrace%2C%20soft%20coral%20pink%20and%20peach%20color%20palette%2C%20dreamy%20atmosphere%20with%20floating%20petals%2C%20elegant%20character%20design%2C%20delicate%20lineart%2C%20romantic%20mood%2C%20webtoon%20style%20illustration%2C%20soft%20lighting%2C%20gentle%20gradient%20background%2C%20clean%20composition%2C%20modern%20manhwa%20aesthetic&width=640&height=900&seq=hero-main-comic-cover&orientation=portrait"
                alt="热门漫画推荐 - 我的契约恋人"
                className="w-full rounded-3xl"
              />
            </div>
          </div>

          <div className="lg:w-[30%] flex flex-col gap-3">
            <div className="flex items-center gap-2 mb-1">
              <span className="w-5 h-5 flex items-center justify-center text-accent-300">
                <i className="ri-fire-line text-sm"></i>
              </span>
              <span className="text-sm font-medium text-background-50/80">热门分类</span>
            </div>
            <div className="grid grid-cols-2 gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/10 hover:border-background-50/25 transition-all duration-200 cursor-pointer group"
                >
                  <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-300 group-hover:bg-primary-500/30 transition-colors">
                    <i className={`${cat.icon} text-xs`}></i>
                  </span>
                  <div className="flex flex-col">
                    <span className="text-sm font-medium text-background-50 whitespace-nowrap">{cat.name}</span>
                    <span className="text-xs text-background-50/50">{cat.count}部</span>
                  </div>
                </Link>
              ))}
            </div>

            <Link
              to="/category/romance"
              className="inline-flex items-center gap-1 mt-2 text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer"
            >
              查看全部分类
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}